document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.variant-picker-lists-content')) return;

    document.addEventListener('click', (e) => {
        const item = e.target.closest('.variant-picker-lists-content--item');
        if (!item) return;

        const variantList = item.closest('.variant-picker-lists-content');
        if (!variantList) return;

        const input = item.querySelector('input');
        if (!input || input.dataset.available === 'disabled') return;

        const productInfo = item.closest('product-info');
        const productForm = productInfo ? productInfo.querySelector('product-form') : document.querySelector('product-form');
        const productVariantID = productForm ? productForm.querySelector('.product-variant-id') : null;
        const ATCbu = productForm ? productForm.querySelector('.product-form__buttons .product-form__submit') : null;

        const selected = variantList.querySelector('.selected');
        if (selected) selected.classList.remove('selected');
        item.classList.add('selected');

        const variantId = input.value;
        if (productVariantID) productVariantID.value = variantId;

        const applyStockState = () => {
            if (!ATCbu) return;
            const span = ATCbu.querySelector('span');
            if (input.dataset.available === 'outstock') {
                ATCbu.setAttribute('disabled', true);
                if (span) span.textContent = input.dataset.date || '';
            } else {
                ATCbu.removeAttribute('disabled');
                if (span) span.textContent = 'Add to cart';
            }
        };

        applyStockState();

        if (!productInfo || typeof productInfo.handleUpdateProductInfo !== 'function') return;

        const requestUrl = `${productInfo.dataset.url}?variant=${variantId}&section_id=${productInfo.dataset.section}`;

        fetch(requestUrl)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                productInfo.handleUpdateProductInfo(productInfo.dataset.url)(html);
                applyStockState();
            })
            .catch((error) => console.error(error));
    });
});
